import React from "react";
import * as R from "ramda";
import { Div, Span, MediumOutlineButton } from "components/Base";
import { connect } from "react-redux";
import { getters, actions } from "../model";
import ContentLoader from "react-content-loader";
import css from "./styles.scss";

const decorate = R.compose(
  connect(
    state => ({
      session: getters.data(state)
    }),
    { openSession: actions.openSession }
  )
);

const TitleLoader = props => (
  <ContentLoader
    speed={1}
    width={500}
    height={33}
    viewBox="0 0 500 33"
    {...props}
  >
    <rect x="0" y="4" rx="0" ry="0" width="500" height="33" />
  </ContentLoader>
);

const CustomHeader = ({ hideModal, openSession, session }) => (
  <Div
    styleName="header"
    display="row.space-between.center"
    className={css.headerMobile}
  >
    <div styleName="title" className={css.titleMobile}>
      <Div className={css.containerMobile}>
        <Div className={css.titleMobile}>
          <Div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row"
            }}
            mr={2}
          >
            <Div
              fs={6}
              color="black"
              fw="4"
              mr={2}
              width={1}
              mb={3}
              style={{
                fontWeight: "700",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word"
              }}
            >
              <h1
                style={{
                  margin: 0,
                  fontSize: "26px"
                }}
              >
                {!session.title ? <TitleLoader /> : session.title}
              </h1>
            </Div>
          </Div>
        </Div>
        <Div display="row.flex-start.center">
          {!R.prop("isSubsession", session) && (
            <Div className={css.viewSubmissionButtonMobile}>
              <MediumOutlineButton onClick={openSession}>
                View Submission
              </MediumOutlineButton>
            </Div>
          )}
          {session.statusLabel ? (
            <>
              <Div ml={3}>
                <Span fw={3}>Status:</Span>&nbsp;{session.statusLabel}
              </Div>
              <Div ml={2} fw={4} color="gray8">
                &middot;
              </Div>
            </>
          ) : null}

          <Div ml={3}>
            <Span fw={3}>ID:</Span>&nbsp;{session.friendlyId}
          </Div>
        </Div>
      </Div>
    </div>
    {hideModal && (
      <div
        onClick={hideModal}
        style={{
          cursor: "pointer"
        }}
        className={css.closeIconMobile}
      >
        <i className="material-icons">close</i>
      </div>
    )}
  </Div>
);

export default decorate(CustomHeader);
